<template>

    <div style="background-color:#f9f9f9;border-bottom:0px solid #ddd;">

        <div class="container" style="border-right:1px solid #eee;border-bottom:1px solid #eee;border-left:1px solid #eee;background-color:#f5f5f5;padding-top:10px;padding-bottom:10px;;border-top:0px solid #ddd;font-size:18px;">


          <div class="row align-items-center">
              <div class="col-9">

            <router-link :to="{ name: 'home' }">
              <template>Home</template>
            </router-link> &gt; 
            <template v-if="factsheet && factsheet.info">
              <router-link :to="{ name: 'factsheet', params: { factsheet_id: factsheet.identifier}}">
                  <strong><span v-if="factsheet.info.location.name">{{ factsheet.info.location.name}}</span><span v-else> {{ factsheet.info.location.identifier}}</span></strong>
              </router-link>
            </template>
            <template v-else-if="project">
              <template>Projects</template> &gt; 
                  <strong><span>{{ project.name}}</span></strong> &nbsp;
                  <span class="badge badge-success" style="font-size:0.9em;" v-if="project.is_public">Open Access</span>
            </template>
            <template v-else>
              <template>Overview</template>
            </template>
        
              </div>





              <div class="col-3 text-right">
                <a href="#" v-if="(profile.is_admin) || (!profile.is_ldr)" @click.prevent="createStart" class="btn btn-primary"><strong><i class="bi bi-stars"></i>&nbsp;&nbsp;Create New Factsheet</strong></a>
              </div>
            </div>



        </div>



    </div>
</template>


<script>
  
  export default {
    name: 'subheader',
    props: ['location', 'factsheet', 'project', 'loaded'],
    components: {
    },
    computed: {
        profile() {
          return this.getProfile();
        }
    },
    methods: {
    }
  }
</script>